export default {
    methods: {

        ordenarPorIdentificacaoSequencial(itens, index, isDesc) {
            if(index === 'sequencia'){
                itens.sort((itemA, itemB) => {

                    const numIdentificacaoSequencialA = this.retornaNumeroIdentificacaoSequencial(itemA)
                    const numIdentificacaoSequencialB = this.retornaNumeroIdentificacaoSequencial(itemB)

                    if (isDesc) {
                        return this.compararItensDescendente(numIdentificacaoSequencialA, numIdentificacaoSequencialB)
                    }
                    return this.compararItensAscendente(numIdentificacaoSequencialA, numIdentificacaoSequencialB)
                })
            }

            return itens
        },

        ordenarPorSequenciaDeInteiros(itens, index, isDesc) {
            if(index === 'sequencia'){
                itens.sort((itemA, itemB) => {

                    const numIdentificacaoSequencialA = this.retornaNumeroSequencia(itemA)
                    const numIdentificacaoSequencialB = this.retornaNumeroSequencia(itemB)

                    if (isDesc) {
                        return this.compararItensDescendente(numIdentificacaoSequencialA, numIdentificacaoSequencialB)
                    }
                    return this.compararItensAscendente(numIdentificacaoSequencialA, numIdentificacaoSequencialB)
                })
            }

            return itens
        },
        retornaNumeroSequencia(item) {
            return item.sequencia
        },
        retornaNumeroIdentificacaoSequencial({ identificacaoSequencial }) {

            if (typeof(identificacaoSequencial) !== 'string')
                return identificacaoSequencial

            const numeroIdentificacaoSequencial = identificacaoSequencial.replace(/\D/g,'')
            return Number(numeroIdentificacaoSequencial)
        },
        compararItensDescendente(idSequencialItemA, idSequencialItemB) {
            if (idSequencialItemA < idSequencialItemB) return 1

            if (idSequencialItemA > idSequencialItemB) return -1

            return 0
        },
        compararItensAscendente(idSequencialItemA, idSequencialItemB) {
            if (idSequencialItemA > idSequencialItemB) return 1

            if (idSequencialItemA < idSequencialItemB) return -1

            return 0
        }
    }
}